import { useEffect } from 'react';
import { Banner } from '../components';
import { Flex } from '../style.js';
import { sizes, utils } from '../variables';
import { accessHome } from '../api';

const Home = () => {
  useEffect(() => {
    // log access to home screen
    accessHome();
  }, []);
  return <Flex
    flexDirection="column"
    alignItems="center"
    width={utils.width.full}
    mt={sizes.md}
  >
    <Banner />
  </Flex>
}

export default Home;